import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { FormData } from '../../types/contact';
import { createContact } from '../../services/contactus';
import { useNavigate } from 'react-router-dom';

const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    phone: yup
        .string()
        .matches(/^[0-9+\s-]+$/, 'Phone number is not valid')
        .required('Phone number is required'),
    company: yup.string().required('Company name is required'),
    message: yup.string().required('Message is required'),
});
function ContactForm() {
    const navigate = useNavigate();

    const methods = useForm({
        resolver: yupResolver(schema),
        mode: "all"
    })
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = methods

    const onSubmit = async (data: FormData) => {
        const response = await createContact(data);
        if (response.success) {
            reset();
            navigate('/');
        }
    };

    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <section className="py-12 lg:py-24">
                        <div className="w-full max-w-[1268px] mx-auto px-4">
                            <div className="flex flex-wrap items-center -mx-4">
                                <div className="w-full max-w-full px-4">
                                    <h2 className="text-[30px] lg:text-[40px] xl:text-[50px] font-semibold !leading-[1.5] text-[#020303] mb-2 text-center">We'd Love to Hear From You</h2>
                                    <p className="text-[18px] sm:text-[20px] lg:text-[22px] xl:text-[24px] font-light !leading-[1.5] text-[#020303] max-w-[850px] mx-auto text-center mb-12 lg:mb-24">To know more about our services, please fill in the details below and one of our representative will get back you to shortly.</p>
                                    <div className="flex flex-wrap items-stretch -mx-6">
                                        <div className="w-full lg:w-1/2 max-w-full px-6 mb-4">
                                            <div className="flex flex-col gap-y-4 lg:gap-y-8 h-full ">
                                                <div>
                                                    <input type="text" {...register('name')} className={`text-base sm:text-[18px] lg:text-[22px] font-light !leading-[1.5] text-[#020303] border py-4 px-5 placeholder-[#020303] outline-none w-full ${errors.name ? 'border-red-500 focus:border-red-500' : 'border-[#000000] hover:border-[#009fe3] focus:border-[#009fe3]'}`} placeholder="Your name" />
                                                </div>
                                                <div>
                                                    <input type="email" {...register('email')} className={`text-base sm:text-[18px] lg:text-[22px] font-light !leading-[1.5] text-[#020303] border py-4 px-5 placeholder-[#020303] outline-none w-full ${errors.email ? 'border-red-500 focus:border-red-500' : 'border-[#000000] hover:border-[#009fe3] focus:border-[#009fe3]'}`} placeholder="Your email" />
                                                </div>
                                                <div>
                                                    <input type="tel" {...register('phone')} className={`text-base sm:text-[18px] lg:text-[22px] font-light !leading-[1.5] text-[#020303] border py-4 px-5 placeholder-[#020303] outline-none w-full ${errors.phone ? 'border-red-500 focus:border-red-500' : 'border-[#000000] hover:border-[#009fe3] focus:border-[#009fe3]'}`} placeholder="Your phone number" />
                                                </div>
                                                <div>
                                                    <input type="text" {...register('company')} className={`text-base sm:text-[18px] lg:text-[22px] font-light !leading-[1.5] text-[#020303] border py-4 px-5 placeholder-[#020303] outline-none w-full ${errors.company ? 'border-red-500 focus:border-red-500' : 'border-[#000000] hover:border-[#009fe3] focus:border-[#009fe3]'}`} placeholder="Your company" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-full lg:w-1/2 max-w-full px-6 mb-4">
                                            <div className="flex flex-col gap-y-8 h-full">
                                                <textarea {...register('message')} className={`text-base sm:text-[18px] lg:text-[22px] font-light !leading-[1.5] text-[#020303] border py-4 px-5 placeholder-[#020303] outline-none resize-none h-full w-full ${errors.message ? 'border-red-500 focus:border-red-500' : 'border-[#000000] hover:border-[#009fe3] focus:border-[#009fe3]'}`} placeholder="Your message"></textarea>
                                            </div>
                                        </div>
                                        <div className="w-full max-w-full px-6 mt-10 lg:mt-16">
                                            <button type="submit" className="flex justify-center items-center gap-3 text-base sm:text-[18px] lg:text-[22px] font-semibold !leading-[1.5] text-[#ffffff] bg-[#009FE3] py-4 px-12 hover:bg-[#020303] transition-all duration-300 ease-in-out mx-auto">Send  message <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="13" r="12.5" stroke="white" /><path d="M8.31982 13H17.6798" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M12.9995 8.31995L17.6795 12.9999L12.9995 17.6799" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </form>
            </FormProvider >
        </>
    )
}

export default ContactForm
